// Add your custom JS here.
const body = document.getElementsByTagName('body')[0];
const isHome = body.classList.contains('home');

const fixedElm = document.getElementById('main-nav');
let scrollPoint = 0;
let lastPoint = 0;

if (isHome) {
  const elemTop = document.getElementById('sticky-01').getBoundingClientRect().top;
  window.addEventListener('scroll', () => {
    scrollPoint = window.scrollY;
    if (elemTop > scrollPoint || 0 > scrollPoint - lastPoint) {
      console.log('remove fixed-hide');
      fixedElm.classList.remove('fixed-hide');
    } else {
      console.log('add fixed-hide');
      fixedElm.classList.add('fixed-hide');
    }
    lastPoint = scrollPoint;
  });
} else {
  window.addEventListener('scroll', () => {
    scrollPoint = window.scrollY;
    if (0 > scrollPoint - lastPoint) {
      console.log('remove fixed-hide');
      fixedElm.classList.remove('fixed-hide');
    } else {
      console.log('add fixed-hide');
      fixedElm.classList.add('fixed-hide');
    }
    lastPoint = scrollPoint;
  });
}



